<style scoped lang="scss" type="text/scss">
    .consignee-container {
        margin: -1rem 0 0 -1rem;
        display: flex;
        flex-wrap: wrap;

        .consignee-item {
            margin: 1rem 0 0 1rem;
        }

        .placeholder {
            margin: 1rem 0 0 1rem;
        }
    }
</style>

<template>
    <div class="consignee-container">
        <consignee-item class="consignee-item" v-for="(item, index) in consignees" :key="index"
                        :info="item" :index="index + 1"
        >
        </consignee-item>
        <placeholder v-if="consignees.length === 0" class="placeholder">
            未填写收件信息
        </placeholder>
    </div>
</template>

<script>
    import ConsigneeItem from '../consignee-item';
    import Placeholder from '@/components/placeholder/index';

    export default {
        name: '',
        props: {
            data: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        components: {
            ConsigneeItem,
            Placeholder
        },
        computed: {
            consignees () {
                if (this.data === null) return [];
                return [this.data];
            }
        },
        data () {
            return {};
        }
    };
</script>
